import { getLocalAgentBridge } from '@/features/assistant/bridge/local-agent-bridge-runtime'
import { VideoCutMcpServer } from './mcp-server'

let mcpServerSingleton: VideoCutMcpServer | null = null

export function getVideoCutMcpServer(): VideoCutMcpServer {
  if (!mcpServerSingleton) {
    mcpServerSingleton = new VideoCutMcpServer()
  }

  return mcpServerSingleton
}

declare global {
  interface Window {
    __VIDEOCUT_MCP_SERVER__?: VideoCutMcpServer
    __VIDEOCUT_LOCAL_AGENT_BRIDGE__?: ReturnType<typeof getLocalAgentBridge>
  }
}

export function registerVideoCutMcpGlobals(): void {
  if (typeof window === 'undefined') {
    return
  }

  window.__VIDEOCUT_MCP_SERVER__ = getVideoCutMcpServer()
  window.__VIDEOCUT_LOCAL_AGENT_BRIDGE__ = getLocalAgentBridge()
}
